import { React, Component, Fragment } from 'react';
import { Accordion, Card } from 'react-bootstrap'
import '../css/NewInfoBox.css'

const Kalpi = props => (
    <Card className="kalpiCard">
        <Card.Subtitle className='NormalTextSize'>{props.name}</Card.Subtitle>
        <Card.Body className='NormalTextSize no-padding'>{props.votes}</Card.Body>
    </Card>
);

const Cluster = props => (
    <Accordion.Item eventKey={`${props.cluster.cluster_num}`}>
        <Accordion.Header>{"מחוז מס' "}{props.cluster.cluster_num}{": "}{props.cluster.votes}{" קולות"}</Accordion.Header>
        <Accordion.Body className='AccordionBodyWrap' >
            {props.kalpiesToShow.map((kalpi, index) => <Kalpi key={index} name={kalpi.name} votes={kalpi.votes} />)}
        </Accordion.Body>
    </Accordion.Item>
)

const cleanName = address => {
    return address.replace(", ישראל", "").replace(/,(\d*)$/, " $1");
}

const fixKalpi = kalpi => {
    return { name: cleanName(kalpi.address), votes: kalpi.votes }
}

class NewInfoBox extends Component {
    render() {
        // TODO add title with cityToShow, edit strings of each cluster
        return <Fragment>
            <Accordion alwaysOpen className='AccordionContainer'>
                {
                    this.props.clustersToShow.map(cluster => {
                        return <Cluster
                            className="ClusterContainer"
                            key={cluster.cluster_num}
                            cluster={cluster}
                            color={cluster.color}
                            kalpiesToShow={
                                this.props.kalpiesToShow.filter(kalpi => kalpi.cluster_num === cluster.cluster_num).map(fixKalpi)
                            } />
                    })
                }
            </Accordion >
        </Fragment>;
    }
}

export default NewInfoBox;